export default __webpack_public_path__ + "static/media/cleaning.918cc5de.jpg";